import Vue from 'vue';

const attachmentsModule = {
  state: {
    showPreview: false,
    selectedAttachment: {},
    currentAttachments: [],
  },

  getters: {
    showPreview: (state) => state.showPreview,
    selectedAttachment: (state) => state.selectedAttachment,
    currentAttachments: (state) => state.currentAttachments,
  },

  mutations: {
    SET_SHOW_PREVIEW: (state, value) => {
      Vue.set(state, 'showPreview', value);
    },
    SET_SELECTED_ATTACHMENT: (state, attachment) => {
      Vue.set(state, 'selectedAttachment', attachment);
    },
    SET_CURRENT_ATTACHMENTS: (state, attachments) => {
      Vue.set(state, 'currentAttachments', attachments);
    },
  },

  actions: {
    toggleShowPreview(context, toggleValue) {
      context.commit('SET_SHOW_PREVIEW', toggleValue);
    },
    updateSelectedAttachment(context, attachment) {
      context.commit('SET_SELECTED_ATTACHMENT', attachment);
    },
    updateAttachmentsArray(context, attachments) {
      context.commit('SET_CURRENT_ATTACHMENTS', attachments);
    },
  },
};

export default attachmentsModule;
